import { z } from 'zod';

export const schema = z.object({
  code: z.string().min(6),
});

export type FormCodeVerification = z.infer<typeof schema>;
